module.exports = __webpack_public_path__ + "static/media/day.5c2290d6.svg";